import { DefaultOptions, QueryClient, QueryClientConfig } from '@tanstack/react-query';
import { isAuthError } from '../../provider/types';

const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (isAuthError(error)) return false;
  return failureCount < 5;
};

const defaultConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    retryDelay: (retryCount: number): number => 1000 * 2 ** retryCount,
    retry: shouldRetry,
  },
  mutations: {
    useErrorBoundary: (error: unknown) => isAuthError(error),
  },
};

export const queryClient = (config?: QueryClientConfig) =>
  new QueryClient({
    ...config,
    defaultOptions: { ...defaultConfig, ...config?.defaultOptions },
  });
